/* src/app/modules/shared/components/header-column/header-column-strain-type/header-column-strain-type.component.scss */
app-header-column-strain-type {
  display: contents;
}
/*# sourceMappingURL=header-column-strain-type.component.css.map */
